// Trusted developer root public key (Base64url or hex matching .keys/dev-ed25519.pub)
export const TRUSTED_DEV_PUBLIC_KEY_B64 = 
  'AAAAC3NzaC1lZDI1NTE5AAAAIJHJYo7MNTQh+TpCcvLpnaEqhdxlQDXga0A0pURS4nJd'; // from .keys/dev-ed25519.pub

function base64UrlToBytes(base64url: string): Uint8Array {
  const base64 = base64url.replace(/-/g, '+').replace(/_/g, '/');
  const padLen = (4 - (base64.length % 4)) % 4;
  const raw = atob(base64.padEnd(base64.length + padLen, '='));
  const bytes = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) bytes[i] = raw.charCodeAt(i);
  return bytes;
}

export async function computeSha256(data: ArrayBuffer | Uint8Array): Promise<string> {
  const hashBuf = await crypto.subtle.digest('SHA-256', data as BufferSource);
  const hashArr = Array.from(new Uint8Array(hashBuf));
  return 'sha256:' + hashArr.map((b) => b.toString(16).padStart(2, '0')).join('');
}

export async function verifyEd25519Signature(
  message: string,
  signatureBase64Url: string,
  publicKeyRaw: Uint8Array | string
): Promise<boolean> {
  try {
    let rawKeyBytes: Uint8Array;
    if (typeof publicKeyRaw === 'string') {
      const decoded = base64UrlToBytes(publicKeyRaw);
      // If it's an SSH key format, the last 32 bytes are the raw Ed25519 key
      if (publicKeyRaw.startsWith('AAAAC3NzaC1lZDI1NTE5AAAAI')) {
         rawKeyBytes = decoded.slice(decoded.length - 32);
      } else {
         rawKeyBytes = decoded;
      }
    } else {
      rawKeyBytes = publicKeyRaw;
    }

    const key = await crypto.subtle.importKey(
      'raw',
      rawKeyBytes as BufferSource,
      { name: 'Ed25519', namedCurve: 'Ed25519' },
      false,
      ['verify']
    );

    const sigBytes = base64UrlToBytes(signatureBase64Url);
    const msgBytes = new TextEncoder().encode(message);

    return await crypto.subtle.verify({ name: 'Ed25519' }, key, sigBytes as BufferSource, msgBytes as BufferSource);
  } catch (err) {
    console.error('[CryptoGate] Ed25519 signature verification failed:', err);
    return false;
  }
}
